import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const getVacancies = () => {
    return qportalApi.get(`Vacancy`);
};
const getVacancyById = (Id) => {
    return qportalApi.get(`Vacancy/${Id}/GetVacancyById`);
};
const applyVacancy = (application) => {
    const formData = convertModelToFormData(application);
    return qportalApi.postForm('Vacancy', formData);
};
const filterVacancy = (filterRequest) => {
    return qportalApi.post('Vacancy/GetVacanciesByFilterValue', filterRequest);
};
const VacanyApi = {
    getVacancies,
    getVacancyById,
    applyVacancy,
    filterVacancy
};
export default VacanyApi;
